import React from 'react';
import EmailIcon from '@material-ui/icons/MailOutlineOutlined';
import SMSIcon from '@material-ui/icons/SmsOutlined';
import Checkbox from './Checkbox';
import { isMobileOnly } from 'react-device-detect';

const SubscriptionsCheckbox = ({ item, data, ...rest }) => {
    return (
        <div className="subscriptions__item">
            <div className="subscriptions__item--checkbox">
                <Checkbox {...rest} item={item} data={data} id={`subscription-${item.name}`} />
            </div>
            <div className="subscriptions__item--icon">
                {
                    {
                        sms: <SMSIcon />,
                        newsletter: <EmailIcon />,
                    }[item.name]
                }
            </div>
            <label className="subscriptions__item--lead" htmlFor={`subscription-${item.name}`}>
                <div className="subscriptions__item--title">{item.label}</div>
                {!isMobileOnly && <div className="subscriptions__item--desc">{item.textHelper}</div>}
            </label>
            {isMobileOnly && <div className="subscriptions__item--desc">{item.textHelper}</div>}
        </div>
    );
};

export default SubscriptionsCheckbox;
